module.exports = __webpack_public_path__ + "static/img/许强 (2).b62980da.png";